import { render } from "./FormOrder.vue?vue&type=template&id=a6784b8c&scoped=true"
import script from "./FormOrder.vue?vue&type=script&lang=js"
export * from "./FormOrder.vue?vue&type=script&lang=js"

import "./FormOrder.vue?vue&type=style&index=0&id=a6784b8c&scoped=true&lang=scss"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6784b8c"]])

export default __exports__